import { PhotoCameraOutlined } from '@mui/icons-material';
import { Avatar, Badge, CircularProgress, IconButton, Tooltip } from '@mui/material';
import type { FC } from 'react';

import useTranslate from 'hooks/useTranslate';

interface ProfileAvatarProps {
    src?: string;
    alt: string;
    uploading: boolean;
    onFileSelect: (file?: File) => void;
}

export const ProfileAvatar: FC<ProfileAvatarProps> = ({ src, alt, uploading, onFileSelect }) => {
    const { translate } = useTranslate();

    return (
        <Badge
            overlap="circular"
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            badgeContent={
                <Tooltip title={translate('changePhoto')}>
                    <span>
                        <IconButton
                            component="label"
                            size="small"
                            aria-label={translate('changePhoto')}
                            disabled={uploading}
                            sx={{
                                borderRadius: '50%',
                                bgcolor: 'background.paper',
                                border: '1px solid',
                                borderColor: 'divider',
                                '&:hover': {
                                    bgcolor: 'background.paper',
                                    borderColor: 'primary.main',
                                },
                            }}
                        >
                            {uploading ? (
                                <CircularProgress size={16} />
                            ) : (
                                <PhotoCameraOutlined sx={{ fontSize: 18 }} />
                            )}
                            <input
                                hidden
                                type="file"
                                accept="image/*"
                                onChange={(e) => onFileSelect(e.target.files?.[0])}
                            />
                        </IconButton>
                    </span>
                </Tooltip>
            }
        >
            <Avatar src={src} alt={alt} sx={{ width: 80, height: 80 }} />
        </Badge>
    );
};
